<template>
  <div class="dsfa-sc-schedule">
    <DsfSCPanel title="日程安排" :more="true" :setting="true">
      <dsf-virtual-scroll scroll-Y>
        <DsfTeasUniteScheduleList
          :dataList="dataList"
        ></DsfTeasUniteScheduleList>
      </dsf-virtual-scroll>
    </DsfSCPanel>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSCSchedule",
  ctrlCaption: "日程安排",
  mixins: [$mixins.control],
  data() {
    return {
      dataList: [],
    };
  },
  created() {
    this.$http.get("/static/data/dsf.scschedule.json").then(({ data }) => {
      this.dataList = data.dataList;
    });
  },
  methods: {},
});
</script>
